import * as types from '../types/language.types';

// eslint-disable-next-line import/prefer-default-export
export const setAppLanguage = (language) => ({
  type: types.SET_APP_LANGUAGE,
  payload: language,
});
